// Eskom PARCC — route-level error boundary element.
//
// Attached as the layout route's `errorElement`, so any error thrown while
// rendering a screen (or its loader, once Phase-2 data pages add them) is
// contained here instead of blanking the whole app. The message is shown only as
// a short, safe string — `error.message` / `String(error)`, never a stack dump —
// so it stays informative in dev without leaking internals in prod copy.
import { Link, useRouteError, isRouteErrorResponse } from 'react-router-dom';

/** Extract a short, safe message from whatever was thrown. */
function errorMessage(error: unknown): string {
  if (isRouteErrorResponse(error)) {
    return `${error.status} ${error.statusText}`;
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return String(error);
}

export function RouteError(): React.JSX.Element {
  const error = useRouteError();
  return (
    <section className="card">
      <div className="callout">
        <strong>Something went wrong.</strong> An unexpected error stopped this page from
        loading.
      </div>
      <p className="small">{errorMessage(error)}</p>
      <Link to="/dashboard" className="btn primary">
        Back to Dashboard
      </Link>
    </section>
  );
}
